import api from "../services/api"

const jwt = require("jsonwebtoken")

const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY
const SECRET = process.env.REACT_APP_SECRET
const USERID_KEY = process.env.REACT_APP_USERID_KEY
const USERFULLNAME_KEY = process.env.REACT_APP_USERFULLNAME_KEY
const USERKIND_KEY = process.env.REACT_APP_USERKIND_KEY
const USERCLASS_KEY = process.env.REACT_APP_USERCLASS_KEY
const USERIMGID_KEY = process.env.REACT_APP_USERIMGID_KEY
const NEWREGID_KEY = process.env.REACT_APP_NEWREGID_KEY
const NEWREGKIND_KEY = process.env.REACT_APP_NEWREGKIND_KEY
const SMARTCHATACCESS_KEY = "smartflow_smart_chat_access"
const USEREMAIL_KEY = "smartflow_user_email"
const CANMANAGEPERMISSIONS_KEY = "smartflow_can_manage_permissions"
//====== WR data 09/09/2026 — flag de acesso ao SmartFlow Importer / Parceiros Importados
const SMARTFLOWIMPORTERACCESS_KEY = "smartflow_importer_access"
// Mesmo padrão de SMARTFLOWIMPORTERACCESS_KEY — controla só a visibilidade do menu
// "Cronograma"/"Índice de Cronogramas"; quem pode editar dentro da tela é decidido por
// isConsulting() (class "CG"), não por essa flag.
const CRONOGRAMAACCESS_KEY = "smartflow_cronograma_access"
const USERCUSTOMERID_KEY = "smartflow_user_customer_id"
const USERCUSTOMERNAME_KEY = "smartflow_user_customer_name"

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null

export const isTokenValid = async () => {
  try {
    await api.get("/user/read/" + localStorage.getItem(USERID_KEY))
    return true
  } catch (err) {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USERID_KEY)
    localStorage.removeItem(USERFULLNAME_KEY)
    localStorage.removeItem(USERKIND_KEY)
    localStorage.removeItem(USERCLASS_KEY)
    localStorage.removeItem(USERIMGID_KEY)
    localStorage.removeItem(NEWREGID_KEY)
    localStorage.removeItem(NEWREGKIND_KEY)
    return false
  }
}

export const isManager = () =>
  jwt.verify(localStorage.getItem(USERKIND_KEY), SECRET, (err, decoded) => {
    if (err) {
      console.log("erro: " + err)
      return false
    } else {
      return decoded.key === "M"
    }
  })

export const isConsulting = () =>
  jwt.verify(localStorage.getItem(USERCLASS_KEY), SECRET, (err, decoded) => {
    if (err) {
      console.log("erro: " + err)
      return false
    } else {
      return decoded.key === "CG"
    }
  })

export const isDemo = () =>
  jwt.verify(localStorage.getItem(USERFULLNAME_KEY), SECRET, (err, decoded) => {
    if (err) {
      console.log("erro: " + err)
      return false
    } else {
      return (
        decoded.key === "Demo Gestor Golive" ||
        decoded.key === "Demo Gestor Cliente" ||
        decoded.key === "Demo Consultor Golive" ||
        decoded.key === "Demo Usuario Chave"
      )
    }
  })

export const userFullName = () =>
  jwt.verify(localStorage.getItem(USERFULLNAME_KEY), SECRET, (err, decoded) => {
    if (err) {
      console.log("erro: " + err)
      return ""
    } else {
      return decoded.key
    }
  })

export const userId = () => {
  return localStorage.getItem(USERID_KEY)
}

export const canAccessSmartChat = () =>
  localStorage.getItem(SMARTCHATACCESS_KEY) === "true"

export const canAccessPermissions = () =>
  localStorage.getItem(CANMANAGEPERMISSIONS_KEY) === "true"

export const canAccessSmartflowImporter = () =>
  localStorage.getItem(SMARTFLOWIMPORTERACCESS_KEY) === "true"

export const canAccessCronograma = () =>
  localStorage.getItem(CRONOGRAMAACCESS_KEY) === "true"

// Cliente ao qual o usuário está vinculado (só existe pra usuário "CR" —
// ligado a 1 cliente só; consultor "CG" não tem cliente fixo). Usado pra
// travar automaticamente o filtro de cliente do SmartChat, sem precisar de
// dropdown, quando quem está perguntando já é de um cliente específico.
export const getUserCustomer = () => {
  const id = localStorage.getItem(USERCUSTOMERID_KEY)
  if (!id) return null
  return { id, name: localStorage.getItem(USERCUSTOMERNAME_KEY) || "" }
}

export const getToken = () => localStorage.getItem(TOKEN_KEY)

export const login = (data) => {
  localStorage.setItem(TOKEN_KEY, data.token)
  localStorage.setItem(USERID_KEY, data.user._id)
  localStorage.setItem(
    USERFULLNAME_KEY,
    jwt.sign({ key: data.user.fullName }, SECRET)
  )
  localStorage.setItem(USERKIND_KEY, jwt.sign({ key: data.user.kind }, SECRET))
  localStorage.setItem(
    USERCLASS_KEY,
    jwt.sign({ key: data.user.class }, SECRET)
  )
  localStorage.setItem(USERIMGID_KEY, data.user.image)
  localStorage.setItem(SMARTCHATACCESS_KEY, String(!!data.user.smartChatAccess))
  localStorage.setItem(
    SMARTFLOWIMPORTERACCESS_KEY,
    String(!!data.user.smartflowImporterAccess)
  )
  localStorage.setItem(
    CRONOGRAMAACCESS_KEY,
    String(!!data.user.cronogramaAccess)
  )
  localStorage.setItem(USEREMAIL_KEY, data.user.email || "")
  localStorage.setItem(
    CANMANAGEPERMISSIONS_KEY,
    String(!!data.user.canManagePermissions)
  )

  if (data.user.customer?._id) {
    localStorage.setItem(USERCUSTOMERID_KEY, data.user.customer._id)
    localStorage.setItem(
      USERCUSTOMERNAME_KEY,
      data.user.customer.shortName || data.user.customer.fullName || ""
    )
  } else {
    localStorage.removeItem(USERCUSTOMERID_KEY)
    localStorage.removeItem(USERCUSTOMERNAME_KEY)
  }
}

export const logout = () => {
  localStorage.removeItem("sl_session_id")
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USERID_KEY)
  localStorage.removeItem(USERFULLNAME_KEY)
  localStorage.removeItem(USERKIND_KEY)
  localStorage.removeItem(USERCLASS_KEY)
  localStorage.removeItem(USERIMGID_KEY)
  localStorage.removeItem(NEWREGID_KEY)
  localStorage.removeItem(NEWREGKIND_KEY)
  localStorage.removeItem(SMARTCHATACCESS_KEY)
  localStorage.removeItem(SMARTFLOWIMPORTERACCESS_KEY)
  localStorage.removeItem(CRONOGRAMAACCESS_KEY)
  localStorage.removeItem(USEREMAIL_KEY)
  localStorage.removeItem(CANMANAGEPERMISSIONS_KEY)
  localStorage.removeItem(USERCUSTOMERID_KEY)
  localStorage.removeItem(USERCUSTOMERNAME_KEY)
}
